import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { VideoPlayerComponent } from 'src/app/components/video-player/video-player.component';
import { AccessService } from 'src/app/providers/access/access.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';

@Component({
  selector: 'app-helpvideos',
  templateUrl: './helpvideos.page.html',
  styleUrls: ['./helpvideos.page.scss'],
})
export class HelpvideosPage implements OnInit {

  constructor(
    public popoverController: PopoverController,
    public toastService: ToastService,
    public accessService: AccessService,
    ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }

  playvideo(type) {
    this.popoverController.create({
      component: VideoPlayerComponent,
      componentProps: {type: type,
      },
      cssClass: 'billing-modal',
      showBackdrop: true,
      backdropDismiss: true
    }).then(res => {
      res.present();      
    });
  }
}
